// removed by extract-text-webpack-plugin
module.exports = {"background-purple":"#eff0f4","white":"#ffffff","black":"#000000","textStyleWrapper":"_3iIjnCFPD7jsJ-_CtZk8AB","top":"sBbYdFo8N1-GzQAV7NNXj","overlay":"_3fpoT_ESyns4crxmLlt5Jb","textArea":"z2qO0JbLUYFVf0-JIyuar","input":"tOYBHdL9lqAbXH21SKcGb","bottom":"_2OjaNsYKxC8DpgzEk2BWeN","copyIcon":"CiukAnFITZe_16kB8stgX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/TextStyles/TextStyle/TextStyle.css
// module id = 786
// module chunks = 0